export const MEDIA_EXPIRED_MARKER_PREFIX = '[MEDIA_EXPIRED:';
export const MEDIA_EXPIRED_FALLBACK_TEXT = 'Mídia expirada pela política de retenção';

export interface ExpiredMediaMarker {
  marker: string;
  policy: string;
  mediaType?: string;
  expiredAt?: string;
}

export interface ExpiredMediaContent {
  url: '';
  mediaPath: '';
  needsLoading: false;
  expired: true;
  fallbackText: string;
  marker: string;
  retentionPolicy: string;
  expiredMediaType?: string;
  expiredAt?: string;
}

export function parseExpiredMediaMarker(value: unknown): ExpiredMediaMarker | null {
  if (typeof value !== 'string') return null;

  const marker = value.trim();
  if (!marker.startsWith(MEDIA_EXPIRED_MARKER_PREFIX) || !marker.endsWith(']')) {
    return null;
  }

  const body = marker.slice(MEDIA_EXPIRED_MARKER_PREFIX.length, -1);
  const [policy, ...fieldParts] = body.split(':');
  if (!policy) return null;

  const fields = fieldParts.reduce<Record<string, string>>((acc, part) => {
    const separator = part.indexOf('=');
    if (separator === -1) return acc;
    const key = part.slice(0, separator);
    const fieldValue = part.slice(separator + 1);
    if (key) acc[key] = fieldValue;
    return acc;
  }, {});

  return {
    marker,
    policy,
    mediaType: fields.type,
    expiredAt: fields.expired_at,
  };
}

export function isMediaExpiredMarker(value: unknown): boolean {
  return parseExpiredMediaMarker(value) !== null;
}

export function getExpiredMediaContent(
  content: unknown,
  fallbackMediaType?: string,
): ExpiredMediaContent | null {
  if (content && typeof content === 'object' && (content as any).expired === true) {
    const existing = content as Partial<ExpiredMediaContent>;
    return {
      url: '',
      mediaPath: '',
      needsLoading: false,
      expired: true,
      fallbackText: existing.fallbackText || MEDIA_EXPIRED_FALLBACK_TEXT,
      marker: existing.marker || '',
      retentionPolicy: existing.retentionPolicy || '',
      expiredMediaType: existing.expiredMediaType || fallbackMediaType,
      expiredAt: existing.expiredAt,
    };
  }

  const parsed = parseExpiredMediaMarker(content);
  if (!parsed) return null;

  return {
    url: '',
    mediaPath: '',
    needsLoading: false,
    expired: true,
    fallbackText: MEDIA_EXPIRED_FALLBACK_TEXT,
    marker: parsed.marker,
    retentionPolicy: parsed.policy,
    expiredMediaType: parsed.mediaType || fallbackMediaType,
    expiredAt: parsed.expiredAt,
  };
}

export function getExpiredMediaPreviewText(): string {
  return MEDIA_EXPIRED_FALLBACK_TEXT;
}
